import React from 'react';
import { WarningOutlined } from '@ant-design/icons';
import { ChatPanelMarkdown } from './ChatPanelMarkdown';
import { ChatPanelMessageAttachments } from './ChatPanelMessageAttachments';
import { ChatPanelNavigationActions } from './ChatPanelNavigationActions';
import { readAttachmentsFromMetadata } from './chatPanelAttachments';
import { isKrybotAssistantError, readKrybotErrorText } from './chatPanelKrybotError';
import styles from './ChatPanel.module.css';

export interface ChatPanelAssistantMessageProps {
  text: string;
  type?: string;
  metadata?: Record<string, unknown>;
}

export const ChatPanelAssistantMessage: React.FC<ChatPanelAssistantMessageProps> = ({
  text,
  type,
  metadata,
}) => {
  const messageShape = { who: 'assistant' as const, type, text, metadata };
  const isError = isKrybotAssistantError(messageShape);
  const displayText = isError ? readKrybotErrorText(messageShape) : text;
  const attachments = readAttachmentsFromMetadata(metadata);

  if (isError) {
    return (
      <div className={styles.assistantErrorMessage} data-testid="chat-assistant-error">
        <span className={styles.assistantErrorLabel}>
          <WarningOutlined aria-hidden />
          Krybot error
        </span>
        <p className={styles.assistantErrorText}>{displayText}</p>
      </div>
    );
  }

  return (
    <div className={styles.messageBubble} data-testid="chat-assistant-message">
      <span className={styles.messageWho}>Assistant:</span>
      {displayText ? <ChatPanelMarkdown text={displayText} /> : null}
      <ChatPanelNavigationActions metadata={metadata} />
      <ChatPanelMessageAttachments attachments={attachments} />
    </div>
  );
};
